import { render, staticRenderFns } from "./commondepartment.vue?vue&type=template&id=4f9b0c78&scoped=true"
import script from "./commondepartment.vue?vue&type=script&lang=js"
export * from "./commondepartment.vue?vue&type=script&lang=js"
import style0 from "./commondepartment.vue?vue&type=style&index=0&id=4f9b0c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9b0c78",
  null
  
)

export default component.exports